import { render } from "./AppRequestsPage.vue?vue&type=template&id=20cc47dc&scoped=true&ts=true"
import script from "./AppRequestsPage.ts?vue&type=script&lang=ts"
export * from "./AppRequestsPage.ts?vue&type=script&lang=ts"

import "./AppRequestsPage.vue?vue&type=style&index=0&id=20cc47dc&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cc47dc"]])

export default __exports__